module.exports = __webpack_public_path__ + "img/5-3.cf2c3acc.png";